// extracted by mini-css-extract-plugin
export default {"PrivacyPolicy":"privacyPolicy_PrivacyPolicy__v2wES","content":"privacyPolicy_content__MFbpf","cancelBtn":"privacyPolicy_cancelBtn__DDYVP","agreeBtn":"privacyPolicy_agreeBtn__5IZDU"};